import Vue from "vue";
import { getStationTypes } from "@/data/db";

export default {
  namespaced: true,
  state: {
    all: {},
  },
  getters: {},
  mutations: {
    add(state, model) {
      Vue.set(state.all, model.id, model);
    },
  },
  actions: {
    all({ commit }, all = []) {
      for (let model of all) {
        commit("add", model);
      }
    },
    getAll({ dispatch }) {
      return new Promise((resolve) => {
        const list = getStationTypes();
        dispatch("all", list);
        resolve(list);
      });
    },
  },
};
